const OrientationVideo = [
    {
        key: 1,
        title: "Course Structure",
        video: "https://firebasestorage.googleapis.com/v0/b/brainanalytics-pk.appspot.com/o/VID_20230317_225355.mp4?alt=media&token=c0a7b835-78db-41fa-a1fd-10a1a89fe085",
        dec: "lorem lorem lorem lorem lorem lorem lorem lorem lorem",
    },
    {
        key: 2,
        title: "Course Material - Download",
        video: "",
        dec: "lorem lorem lorem lorem lorem lorem lorem lorem lorem",
    },
    {
        key: 3,
        title: "Course Project",
        video: "",
        dec: "lorem lorem lorem lorem lorem lorem lorem lorem lorem",
    },
    {
        key: 4,
        title: "Important: Regional Settings",
        video: "",
        dec: "lorem lorem lorem lorem lorem lorem lorem lorem lorem",
    },
];

export default OrientationVideo;